import { useEffect } from "react"
import { Grid, IMSPolicy } from "../components"
import { Navbar, Footer } from "../layouts"
import BankvoleLoanTerms from "../components/bankvole-loan-terms"




const BankvoleLoanTerm = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <BankvoleLoanTerms/>
        </>

    )
}

export default BankvoleLoanTerm